export default "__VITE_ASSET__84e30638__"